import React from 'react';
import { useLocation } from "react-router-dom"
import { matchPath } from "react-router";
import { useSnackbar } from 'notistack';
import { colors } from './theme';
import { displayToast } from './store/config/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from './store';
import { ConfigState } from './store/config/types';
import { CeclApiState, MessageAction } from './store/ceclapi/types'
import {
    ceclApiMessagesConfigurationRequest
} from './store/ceclapi/actions';
import Button from './components/button/Button';


function hashCode(s) {
    let h=0;
    for(let i = 0; i < s.length; i++) 
          h = Math.imul(31, h) + s.charCodeAt(i) | 0;

    return h;
}

const Messages = () => {
    const cecl = useSelector<ApplicationState, CeclApiState>((state) => state.cecl);
    const config = useSelector<ApplicationState, ConfigState>((state) => state.config);

    const location = useLocation();
    const dispatch = useDispatch();
    const { closeSnackbar } = useSnackbar();

    const [keys, setKeys] = React.useState({});

    const changeAction = message => (
        <Button sx={{
            backgroundColor: 'transparent',
            border: 'none',
            color: colors.white,
            textDecoration: 'underline',
            '&:hover': {
                backgroundColor: 'transparent'
            }
        }}
        onClick={() => 
            { 
                const email = cecl.user?.email || '';
                const hashText = `${message.messageText}${email}`;
                const hash = hashCode(hashText);
                localStorage.setItem(hash.toString(), 'dismissed');
                closeSnackbar(keys[hash]); 
            }}>
            Dismiss
        </Button>
    );

    if(!cecl?.messageConfig?.messages && !cecl.messageConfig?.loading)            {
        dispatch(ceclApiMessagesConfigurationRequest())
    }

    React.useEffect(() => {
        if (typeof cecl?.messageConfig?.messages !== 'undefined' && cecl.messageConfig.messages.length > 0) {
            for(const message of cecl?.messageConfig?.messages){
                const match = matchPath({ path: message.route, caseSensitive: false, end: true }, location.pathname);
        
                if(match){
                    if(message.action === MessageAction.PermantelyDismissable){
                        const email = cecl.user?.email || '';
                        const hashText = `${message.messageText}${email}`;
                        const hash = hashCode(hashText);
                        const dismissed = localStorage.getItem(hash.toString());
    
                        if(!dismissed || dismissed != 'dismissed')
                        {
                            dispatch(displayToast({message: message.messageText, variant: 'info', anchorOrigin: {vertical: 'top', horizontal: 'center'}, persist: true, action: changeAction(message)}));
                            setKeys({...keys, hash: config.snackbarKey});
                        }
                    }
                    else{
                        dispatch(displayToast({message: message.messageText, variant: 'info', anchorOrigin: {vertical: 'top', horizontal: 'center'}, persist: true}));
                    }
                }
            }
        }

    },[location, cecl.messageConfig, cecl.user])

    return (<></>);
};

export default Messages;
